/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Save_OrderInputs */

const vi_pos_save_order = /** @type {(inputs: Pos_Save_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu đơn`)
};

/**

* @param {Pos_Save_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_save_order = /** @type {((inputs?: Pos_Save_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Save_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_save_order(inputs)
});